import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import * as React from 'react';
import styled from 'styled-components';
import { neutralColors, CTAColors } from '../../styles/colors/colors.js';
import { jsx } from 'react/jsx-runtime';

var StyledBadge = styled.span.withConfig({
  displayName: "Badge__StyledBadge",
  componentId: "sc-q6y3v2-0"
})(["&&{display:inline-block;border-radius:4px;border:2px solid ", ";min-width:24px;padding:0 5px;color:", ";line-height:16px;font-weight:600;font-size:14px;text-align:center;", ";", ";", ";}"], neutralColors.smoke, neutralColors.smoke, function (props) {
  return props.active && "background-color: ".concat(neutralColors.charcoal, ";\n        border-color: ").concat(neutralColors.charcoal, ";\n        color: ").concat(neutralColors.white, "\n    ");
}, function (props) {
  return props.selected && "background-color: ".concat(CTAColors.primary, ";\n        border-color: ").concat(CTAColors.primary, ";\n        color: ").concat(neutralColors.white, "\n    ");
}, function (props) {
  return props._disabled && "background-color: ".concat(neutralColors.pearl, ";\n        border-color: ").concat(neutralColors.pearl, ";\n        color: ").concat(neutralColors.silver, "\n    ");
});
var Badge = /*#__PURE__*/React.forwardRef(function Badge2(props, ref) {
  var styleModifiers = {
    _disabled: props.disabled,
    active: props.active,
    selected: props.selected
  };
  return /*#__PURE__*/jsx(StyledBadge, _objectSpread(_objectSpread(_objectSpread({}, styleModifiers), {}, {
    "aria-disabled": props.disabled
  }, props), {}, {
    ref: ref,
    children: props.count
  }));
});
Badge.propTypes = {
  "active": _PropTypes.bool,
  "count": _PropTypes.number,
  "disabled": _PropTypes.bool,
  "selected": _PropTypes.bool
};
Badge.displayName = "Badge";

export { Badge };
